import axios from 'axios';
import base_api from './base_api';
import store from '../../redux/store';
import { userOperations } from '../../redux/user';

const config = {
  baseURL: __SURCHX_BACKEND_BASE_TEST__,
  headers: {
    "X-Requested-With": "xhr"
  }
};

let axios1 = axios.create(config)
const CancelToken = axios.CancelToken;

axios1.interceptors.request.use(
    async function(config) {
        // Do something before request is sent
        base_api.defaults.headers['Authorization'] =
            'Bearer ' + store.getState().tokenReducer.tokens.loginToken;

        try {
            const response = await base_api.get("check_login");
            if (response.status === 200) {
                return config;
            }

        } catch(error) {
            store.dispatch(userOperations.userLogoutOp());
            // sessionStorage.clear();
            // localStorage.clear();
            // window.location.reload();
            return {
                ...config,
                cancelToken: new CancelToken((cancel) => cancel('Please log in again')),
            };
        }

        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

axios1.interceptors.response.use(null, function (error) {
  if(error && error.response && error.response.status === 401) {
    sessionStorage.clear();
    localStorage.clear();
    // window.location.reload();
  }
  return Promise.reject(error);
});

export default axios1;



// WEBPACK FOOTER //
// ./src/utils/api/surchx_base_api-test.js